import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { isValidUserId } from '../../../../constants/Validators';
import Input from '../TravellerContactInfo/FormFields/Input';
import { trackVerifyUsernameEvent, trackVerifyUsernameLoad } from '../../../../utils/railsAnalytics';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { fetchUserStatusAction } from '../../store/actions/UserActions';
import { customStyles, UserFlowModalState } from '../UserFlow/UserFlowModal';
import './LoginModals.css';
import { If } from 'react-extras';

const initialStates = {
  disabled: true,
  rotate: false,
  rotate_forgotUsername: false,
  validationFail: true,
};

const FailureWrongDetails = (props: UserFlowModalState) => {
  const dispatch = useDispatch();
  const { user: { userStatus } } = useSelector((state: any) => state);
  const [ state, setState ] = useState(initialStates);
  const [ irctcUserId, setIrctcUserId ] = useState('');
  const [ user, setUser ] = useState(_isEmpty(userStatus) ? props.userStatus : userStatus);
  const [ showModal, setShowModal ] = useState(props.showModal || false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (userStatus.nextPage!== props.userStatus.nextPage) {
      const nextUser = props.userStatus.nextPage ? props.userStatus : userStatus;
      setUser(nextUser);
      if(state.rotate) {
        goToVerifiedPage(nextUser);
      }
    }
  }, [ userStatus, props.userStatus ]);

  useEffect(() => {
    trackVerifyUsernameLoad();
    if (user)
      setIrctcUserId(user.userId);
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  const goToVerifiedPage = (userStatus) => {
    // redirects to next user flow page according to the status received
    // nextPage property is set in Node backend.
    if (userStatus.nextPage === 'usernameVerified') {
      props.updateVerifiedUser(userStatus.userId);
    } else {
      props.switchModal(userStatus.nextPage, userStatus);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    props.closeModal();
  };

  const handleInputKeyUpViaParent = (val = '') => {
    if (val && val.length > 0) {
      setIrctcUserId(val);
    } else {
      setState({
        ...state,
        validationFail: false,
      });
      setIrctcUserId(val);
    }

    if (val.length > 0 && isValidUserId(val) ) {
      setState({
        ...state,
        validationFail: false,
      });
    }
    else {
      setState({
        ...state,
        validationFail: true,
      });
    }

    if (val.length >= 3 && isValidUserId(val)) {
      setState({
        ...state,
        disabled: false,
      });
    } else {
      setState({
        ...state,
        disabled: true,
      });
    }
  };

  const rotateLoader=() => {
    if (!state.disabled) {
      setState({
        ...state,
        rotate: true,
      });
      trackVerifyUsernameEvent('irctc_username_verify_clicked');
      dispatch(fetchUserStatusAction(irctcUserId));

      timerRef.current = setTimeout(() => {
        setState({
          ...state,
          rotate: false,
        });
      }, 1500);
    }
  };

  const rotateLoaderForForgotUsername = () => {
    props.switchModal('forgotUsername');
    setState({
      ...state,
      rotate_forgotUsername: true,
    });
    timerRef.current = setTimeout(() => {
      setState({
        ...state,
        rotate_forgotUsername: false,
      });
    }, 1500);
  };

  const goToIRCTCRegistrationPage=() => {
    props.createAccount();
  };

  const { validationFail, disabled, rotate, rotate_forgotUsername } = state;
  const { allowClose } = props;
  const showError = Boolean((userStatus && userStatus.error) || validationFail);
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals htmlv2"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <div className="leftPanel">
        <p className="modalTitle font26 latoBloack blackText">
            Verify IRCTC Username
        </p>
        <p className="font20 latoBold darkGreyText appendBottom10">
            Why Verify?
        </p>
        <p className="font14 darkGreyText appendBottom30">
          <span className="yellowText">This is a compulsory step</span> required by IRCTC to ensure that your booking does not fail after payment.
        </p>
        <div className="makeFlex appendBottom10 end leftWidth100Input">
          <div className={`flexOne customPlaceholder appendRight2 spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName=""
              errorMessage={showError && userStatus && userStatus.error ? userStatus.error : 'No special characters allowed other than \'_\''}
              validationFail={showError}
              type="text"
              additionalAttributes={{ placeholder: 'Enter IRCTC Username and Verify' }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly={false}
              handleInputKeyUpViaParent={ handleInputKeyUpViaParent}
              onEnterClick={rotateLoader}
              value={irctcUserId}
              autoFocus={true}
            />
          </div>
          <button
            onClick={rotateLoader}
            className={`${disabled ? 'disabled' : ''} noShrink appendLeft15`}
          >
            <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>Verify</span>
          </button>
        </div>
        <p className="font12 lightGreyText appendBottom50">
            You can find it in your email inbox registered with IRCTC.
        </p>
        <p className="font14 lineHeight18 maxWidth368">
          <b>Note:</b> IRCTC Username is case sensitive, has 3-35 characters of upper
            and lower case letters , numbers and ‘_’.
        </p>
      </div>
      <div className="rightPanel">
        <If condition={allowClose === true}>
          <p className="textRight modalCloseCont">
            <span
              className="modalClose railSprite crossIcon"
              onClick={closeModal}
            />
          </p>
        </If>

        <p className="font20 latoBold darkGreyText appendBottom30">Wrong Details</p>
        <p className="font14 appendBottom40">Email <span className="redText">{userStatus.emailEntered} is not registered with IRCTC</span> <br /> or<br /> <span className="redText">Date of birth didn’t match</span> the information in your IRCTC account.</p>
        <p className="font12 lightGreyText appendBottom10">Typed something wrong?</p>
        <button
          onClick={rotateLoaderForForgotUsername}
          className={'noShrink appendBottom30'}
        >
          <span className={`${rotate_forgotUsername ? 'btnLoader' : 'font12 latoBlack capText'}`}>Try Again</span>
        </button>
        <p className="font14 darkGreyText appendBottom5">Facing trouble?</p>
        <p className="appendBottom40"><a className="font16 latoBold " onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>
      </div>
    </Modal>
  );
};

export default FailureWrongDetails;
